module.exports = __webpack_public_path__ + "img/time.c404d92d.svg";